// dialogSlice.js
import { createSlice ,PayloadAction} from '@reduxjs/toolkit';



const initialState={
 isEnvSettingDialogOpen:false,
 isFromLogin:false
}

const EnvSettingDialogSlice = createSlice({
  name: 'updatepassdialog',
  initialState,
  reducers: {
    reset: () => initialState,
    openEnvSettingDialog: (state) => {
      state.isEnvSettingDialogOpen = true;
    },
    closeEnvSettingDialog: (state) => {
      state.isEnvSettingDialogOpen = false;
    },
    isFromLogin: (state) => {
      state.isFromLogin = true;
    },
    notFromLogin: (state) => {
      state.isFromLogin = false;
    },
   
  },
});

export const { openEnvSettingDialog, closeEnvSettingDialog,isFromLogin,notFromLogin} = EnvSettingDialogSlice.actions;
export default EnvSettingDialogSlice.reducer;
